import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import Button from "../../ui/Button";

const Agb = () => {
	const language = useSelector((state) => state.app.language);
	const link = language === "de" ? "https://app.rico-brunner.com/doc/de/AGB.pdf" : "https://app.rico-brunner.com/doc/en/GTC.pdf";

	return (
		<div>
			<h1>
				<FormattedMessage id="agb.title" defaultMessage="Allgemeine Geschäftsbedingungen und Widerruf" />
			</h1>
			<p>
				<FormattedMessage id="agb.intro" defaultMessage="Hier findest du unsere allgemeinen Geschäftsbedingungen und Widerruf." />
			</p>
			<Button href={link}>
				<FormattedMessage id="agb.link" defaultMessage="Allgemeine Geschäftsbedingungen und Widerruf als PDF herunterladen" />
			</Button>
		</div>
	);
};

export default Agb;
